import React from 'react';
import Header from '../header';
import Footer from '../footer';
import UnderConstruction from '../underConstruction';

const ProjectsPage = () => {
    return (
        <div>
            <Header />
            <UnderConstruction />
            <Footer />
        </div>
    )
}

export default ProjectsPage;